import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { FlexView, Separator, Text, Button } from '@cuemath/comps';
import { get as getDemoIncentiveData } from 'actions/demo-incentives';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import { connect } from 'react-redux';
import COLORS from 'constants/colors';
import {
  EVENT_TYPE,
  INCENTIVE_STATES,
  MathProduct,
  CodingProduct,
  Remove,
  Add,
} from 'constants/demo-incentive';
import {
  getOnChangeMethod,
  getInputChangeMethod,
  demoIncentiveIds,
} from 'constants/form';
import {
  Message,
  renderFormField,
  FieldWrapper,
  getFormDefaults,
  getFormFields,
} from 'modules/form';
import { format } from 'date-fns';
import IncentiveTables from './incentive-tables';

const MessageWrapper = styled(Message)`
  width: 40%;
`;

const TableHeader = styled(Text)`
  background-color: ${COLORS.HAWKESBLUE};
  border: 1px solid ${COLORS.SCIENCEBLUE};
  border-bottom-color: transparent;
  text-align: center;
  width: 40%;
  padding: 6px;
  margin: 20px 10px 0 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

const TableContainer = styled(Text)`
  border: 1px solid ${COLORS.SILVERCHALICE};
  margin: 0px 10px 40px 10px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
`;

class DemoIncentive extends PureComponent {
  constructor(props) {
    super(props);
    const { filledData } = props;

    this.state = {
      formData: {},
      errorText: null,
      message: null,
      form: getFormDefaults(filledData, demoIncentiveIds),
      formFields: getFormFields(demoIncentiveIds),
      showEvents: false,
      demoIncentivesGet: null,
      patchInitiated: false,
    };
    demoIncentiveIds.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    const { actions, demoIncentiveData } = props;
    const { form } = state;
    const { student_id = null, teacher_id = null } = form || {};

    const ObjForGetDemoIncentive = {
      student_id,
      grouped_by_student: false,
    };

    if (student_id && teacher_id) {
      newState.demoIncentivesGet = store.get(
        demoIncentiveData,
        teacher_id,
        ObjForGetDemoIncentive,
      );
    }

    if (newState.demoIncentivesGet && newState.demoIncentivesGet.isLoaded) {
      newState.teacherDdaSlots = newState.demoIncentivesGet.data;
    }

    if (newState.demoIncentivesGet && newState.demoIncentivesGet.isStale) {
      actions.getDemoIncentiveData(teacher_id, ObjForGetDemoIncentive);
    }

    return newState;
  }

  onFieldChange = (key, value) => {
    const { formData } = this.state;

    this.setState({ formData: { ...formData, [key]: value } });
  };

  onChange = (key, value) => {
    const { form, errorText } = this.state;
    const newForm = { ...form };

    newForm[key] = value;

    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;

    this.setState(() => ({ ...stateChanges }));
  };

  renderFormFields = () => {
    const { formFields, form } = this.state;

    return (
      <FieldWrapper width="50%">
        {formFields.map(field => {
          const { label: placeholder, required } = field || {};

          return renderFormField({
            ...field,
            value: form[field.name],
            onChange: this[getInputChangeMethod(field)],
            required,
            placeholder,
          });
        })}
      </FieldWrapper>
    );
  };

  showEvents = () => {
    const { actions } = this.props;
    const { form } = this.state;
    const { student_id: studentId, teacher_id } = form || {};

    if (!studentId) {
      this.setState({ errorText: 'Please enter Student ID' });
      return;
    }
    if (!teacher_id) {
      this.setState({ errorText: 'Please enter Teacher ID' });
      return;
    }
    const student_id = studentId;
    const obj = {
      student_id,
      grouped_by_student: false,
    };

    this.setState({ patchInitiated: true }, () => {
      actions.getDemoIncentiveData(teacher_id, obj);
    });
  };

  renderButton = () => {
    return (
      <FlexView flexDirection="row" alignItems="center" justifyContent="center">
        <Button label="Show Events" onClick={() => this.showEvents()} />
      </FlexView>
    );
  };

  renderIncentiveData = (
    DemoEnrolledDuplicateData,
    penaltyDataDuplicateData,
    DemoIncentivesDuplicateData,
    penaltyData,
    DemoEnrolledData,
    DemoIncentivesData,
  ) => {
    const { DEMO_COMPLETED, DEMO_ENROLLED, DEMO_TEACHER_NO_SHOW } = EVENT_TYPE;
    const { demoIncentivesGet } = this.state;
    const { data: allIncentiveData } = demoIncentivesGet || {};

    const allIncentiveDataAvailable =
      allIncentiveData && Array.isArray(allIncentiveData) && allIncentiveData.length > 0;

    if (allIncentiveDataAvailable) {
      penaltyData = allIncentiveData.filter(
        ({ event_type: eventType }) => eventType === DEMO_TEACHER_NO_SHOW,
      );
      DemoEnrolledData = allIncentiveData.filter(
        ({ event_type: eventType }) => eventType === DEMO_ENROLLED,
      );
      DemoIncentivesData = allIncentiveData.filter(
        ({ event_type: eventType }) => eventType === DEMO_COMPLETED,
      );
      penaltyDataDuplicateData = [...penaltyData];
      DemoEnrolledDuplicateData = [...DemoEnrolledData];
      DemoIncentivesDuplicateData = [...DemoIncentivesData];
    }
    return [
      DemoIncentivesDuplicateData,
      DemoEnrolledDuplicateData,
      penaltyDataDuplicateData,
    ];
  };

  renderTableData = (
    DemoEnrolledDuplicateData,
    penaltyDataDuplicateData,
    DemoIncentivesDuplicateData,
    penaltyData,
    DemoEnrolledData,
    DemoIncentivesData,
  ) => {
    const { form, patchInitiated } = this.state;

    const allData = this.renderIncentiveData(
      DemoEnrolledDuplicateData,
      penaltyDataDuplicateData,
      DemoIncentivesDuplicateData,
      penaltyData,
      DemoEnrolledData,
      DemoIncentivesData,
    );

    if (allData && allData.length > 0) {
      if (allData.length === 1) {
        DemoIncentivesDuplicateData = allData[0];
      }
      if (allData.length === 2) {
        DemoIncentivesDuplicateData = allData[0];
        DemoEnrolledDuplicateData = allData[1];
      }
      if (allData.length === 3) {
        DemoIncentivesDuplicateData = allData[0];
        DemoEnrolledDuplicateData = allData[1];
        penaltyDataDuplicateData = allData[2];
      }
    }

    const IncentiveTableFields = [
      { heading: 'Penalty', data: penaltyDataDuplicateData },
      { heading: 'Demo Incentives', data: DemoIncentivesDuplicateData },
      {
        heading: 'Enrolment Incentives',
        data: DemoEnrolledDuplicateData,
      },
    ];

    return IncentiveTableFields.map((IncentiveTableData, id) => {
      const { heading, data } = IncentiveTableData || {};

      const showCreateDemoIncentive =
        patchInitiated && heading === 'Demo Incentives' && data.length === 0;

      return (
        <div key={`${heading} - ${id}`}>
          <TableHeader>{heading}</TableHeader>
          <TableContainer>
            <IncentiveTables
              data={
                showCreateDemoIncentive
                  ? [{ action_type: 'Create Demo Incentive' }]
                  : data
              }
              filledData={form}
              createDemoBtn={showCreateDemoIncentive}
            />
          </TableContainer>
        </div>
      );
    });
  };

  render() {
    const { errorText } = this.state;
    let penaltyData = [];
    let DemoEnrolledData = [];
    let DemoIncentivesData = [];
    let DemoEnrolledDuplicateData = [];
    let penaltyDataDuplicateData = [];
    let DemoIncentivesDuplicateData = [];

    return (
      <div>
        <Separator height={10} transparent />
        <FlexView justifyContent="center" alignItems="center">
          <Text justifyContent="center" alignItems="center" size="large" weight="bold">
            Incentive Correction Tool :
          </Text>
          <Separator height={20} transparent />
          {this.renderFormFields()}
          <Separator transparent height={25} />
          {errorText && <MessageWrapper error={true}>{errorText}</MessageWrapper>}
          <Separator transparent height={25} />
          {this.renderButton()}
        </FlexView>
        <Separator height={20} transparent />
        {this.renderTableData(
          DemoEnrolledDuplicateData,
          penaltyDataDuplicateData,
          DemoIncentivesDuplicateData,
          penaltyData,
          DemoEnrolledData,
          DemoIncentivesData,
        )}
        <Separator height={20} transparent />
      </div>
    );
  }
}

DemoIncentive.propTypes = {
  actions: PropTypes.shape({
    getDemoIncentiveData: PropTypes.func.isRequired,
  }).isRequired,
  demoIncentiveData: PropTypes.shape({}).isRequired,
};

export default connect(
  ({ demoIncentiveData }) => ({ demoIncentiveData }),
  dispatch => ({
    actions: bindActionCreators({ getDemoIncentiveData }, dispatch),
  }),
)(DemoIncentive);
